import * as About from "./aboutStyles";

export default function AboutContainer() {
  return (
    <div id="about" data-aos="fade-up">
      <About.HeaderContainer>
        <About.HeaderNumber>01.</About.HeaderNumber>
        <About.HeaderTitle>About Me</About.HeaderTitle>
      </About.HeaderContainer>

      <About.Container>
        <About.TextContainer>
          <About.Text>
            Hello! I'm a Full Stack Developer specializing in building scalable backend systems and secure architectures. I primarily work with Go for backend development, and React and Angular (TypeScript) for frontend applications.
          </About.Text>
          <About.Break />
          <About.Text>
          With expertise in fintech and cloud infrastructure, I've built high-throughput transaction systems, multi-factor authentication solutions, and real-time analytics platforms. I focus on performance optimization, deployment automation, and mentoring teams to deliver maintainable software.
          </About.Text>
          <About.Break />
          <About.Text>Notable Achievements:</About.Text>
          <About.Break />
          <About.ContainerList>
            <About.Item>Designed scalable microservices infrastructure for enterprise systems</About.Item>
            <About.Item>Built transaction and wallet systems handling large-scale operations</About.Item>
            <About.Item>Developed extensible multi-factor authentication (MFA) framework</About.Item>
            <About.Item>Optimized monitoring systems, achieving 2.5x performance improvement</About.Item>
            <About.Item>Graduated Magna Cum Laude as top-performing student and scholar</About.Item>
          </About.ContainerList>
        </About.TextContainer>
        {/* <About.ProfileDiv data-aos="fade-left" data-aos-delay="200">
          <About.ProfileContainer />
          <About.ProfileContainerTwo />
        </About.ProfileDiv> */}
      </About.Container>
    </div>
  );
}
